import React from 'react';
import AddTeamEventPage from './AddTeamEventPage';

const CopyTeamEventPage = () => <AddTeamEventPage variant="copy" />;

export default CopyTeamEventPage;
